import type { Inspection, InspectionBase } from "../../types";
import { createBaseService } from "./baseService";

const base = createBaseService<Inspection, InspectionBase>({
  tableName: "inspections",
  viewName: "inspections_enriched",
  computedColumns: ["templateName", "locationName", "assetName", "conductedByName", "actionCount", "failedItemCount"],
  searchColumns: ["notes", "template_name", "location_name", "asset_name"],
});

export class InspectionService {
  static getAll = base.getAll;
  static get = base.get;
  static create = base.create;
  static update = base.update;
  static delete = base.delete;
}
